// extracted by mini-css-extract-plugin
export default {"container":"reset-password_container__j6O-Y","form":"reset-password_form__qSNoU","link":"reset-password_link__ZVxDu","text":"reset-password_text__zEvd1"};